export const contactsData = {
    email: 'mmasham12@gmail.com',
    phone: '+92 3107741005',
    address: '17-B, Block R 3 Phase 2 Johar Town, Lahore, Punjab 54000, Pakistan',

    sheetAPI: ''
}